<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Sales Team</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

        <div class="form-group">
            <label>Brand</label> 
            <!-- <input type="text" class="form-control"  name="role" [(ngModel)]="data.brand_name" readonly> -->
            <select  #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" #mySelectBrand (change)='BrandSelected(mySelectBrand.value)'>
                <option selected="selected" data-select2-id="1" hidden>{{data.brand_name}}</option>
                <option *ngFor="let d of Brand;index as i" data-select2-id="2" [value]="i">{{d.brand_name}}</option>
                
                </select> 
        </div>
        <div class="form-group">
            <label>Manager</label>

                <!-- <input type="text" class="form-control"  name="role" [(ngModel)]="data.brand_manager_name"> -->
                <div class="input-group ">
                    <input type="search" class="form-control" placeholder="Search employee" [(ngModel)]="data.brand_manager_name" (ngModelChange)="valuechange4($event);SearchEmployee();">
                    <button type="submit" class="btn btn-lg btn-default" style="height: 38px;" (click)="SearchEmployee();">
                    <i class="fa fa-search"></i>
                    </button>
            
                    </div>
            
                    <div class="card card-default"  *ngIf="isShownEmployee">
                        <div *ngFor="let c of employee" >
                        <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)"><b>{{c.employee_name}}</b></h4>
                        </div>
                        </div>
        </div> 

        <div class="form-group">
            <label>Team Mates</label><span class="error">{{TeamMates}}</span>
        
            <ng-multiselect-dropdown
            [placeholder]="'Select Team Mates '"
            [settings]="dropdownSettings"
            [data]="dropdownList"
            allowSearchFilter=true
            (onSelect)="onItemSelect($event)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelect)="onDeSelect($event)"
            (onUnSelectAll)="onDeSelecAll()"
            [(ngModel)]="selectedItems"
           >
           </ng-multiselect-dropdown>
        </div>


      

    </div>

    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">

        <div class="form-group">

            <div class="form-group">
                <label>Team Name</label>
                <input type="text" class="form-control"  name="role" [(ngModel)]="data.team_name" >
            </div>

            <label>Month</label>

                <!-- <input type="text" class="form-control"  name="role" [(ngModel)]="data.month" readonly> -->
                <select  #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" #mySelectMonth (change)='MonthSelected(mySelectMonth.value)'>
                    <option selected="selected" data-select2-id="1" hidden>{{data.month}}</option>
                    <option *ngFor="let d of Month;index as i" data-select2-id="2" [value]="i">{{d.name}}</option>
                        
                    </select>
            </div> 

        

        </div>
        
        <!---------------------------------------------------------->
        </div>

        <mat-form-field >
            <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates" name="excludedDates"
                                [(ngModel)]="model" [min]="minDate" [max]="maxDate">
            </ngx-multiple-dates>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>


        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick();">Submit</button>

    </div>
    </div>

